import FormBuilder, { FormBuilderSaveCallbackResponse } from 'molecules/FormBuilder/FormBuilder'
import { Box } from '@mui/material'
import { useTranslationMapDetailsContext } from '../contexts/TranslationMapDetailsContext'

export interface SettingsDetails {}

export default function SettingsDetails(_props: SettingsDetails) {
  const { viewMode, translationMap, updateTranslationMap } = useTranslationMapDetailsContext()

  const onUpdateFormBuilder = (response: FormBuilderSaveCallbackResponse) => {
    if (updateTranslationMap && translationMap)
      updateTranslationMap({
        settings_data_schema: response.schema,
        settings_ui_schema: response.uiSchema,
      })
  }

  return (
    <Box>
      <FormBuilder
        schema={translationMap?.settings_data_schema}
        uiSchema={translationMap?.settings_ui_schema}
        onUpdate={onUpdateFormBuilder}
      />
    </Box>
  )
}
